import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import RadialChart1 from "./userpanelChart1";
import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";

const UserPanel = ({ leadsStats }) => {
  // Extract data from leadsStats, with fallbacks for loading state
  const overview = leadsStats?.overview || {};
  const growth = leadsStats?.growth || {};
  const activity = leadsStats?.activity || {};
  
  const totalLeads = overview.totalLeads || 0;
  const newThisMonth = overview.newThisMonth || 0;
  const activeLeads = overview.activeLeads || 0;
  const needsFollowUp = overview.needsFollowUp || 0;
  const growthRate = growth.growthRate || 0;
  const openRate = activity.openRate || 0;

  // Determine if growth is positive or negative
  const isGrowthPositive = growthRate >= 0;
  const growthIcon = isGrowthPositive 
    ? "ri-arrow-right-up-line" 
    : "ri-arrow-right-down-line";
  const growthClass = isGrowthPositive ? "text-success" : "text-danger";

  return (
    <React.Fragment>
      <Row>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-1" className="apex-charts" dir="ltr">
                    <RadialChart1 value={Math.abs(growthRate)} max={100} />
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Leads</p>
                  <h5 className="mb-3">{totalLeads.toLocaleString()}</h5>
                  <p className="text-truncate mb-0">
                    <span className={growthClass + " me-2"}>
                      {growthRate >= 0 ? "+" : ""}
                      {growthRate.toFixed(2)}%{" "}
                      <i className={growthIcon + " align-bottom ms-1"}></i>
                    </span>{" "}
                    Crecimiento
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart2
                    id="radialchart-2"
                    className="apex-charts"
                    dir="ltr"
                    value={newThisMonth}
                    max={Math.max(newThisMonth, growth.lastMonth || 1, 100)}
                  />
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Nuevos (Este Mes)</p>
                  <h5 className="mb-3">{newThisMonth.toLocaleString()}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {" "}
                      <i className="ri-user-add-line align-bottom ms-1"></i>
                    </span>{" "}
                    Leads nuevos
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart3
                    id="radialchart-3"
                    className="apex-charts"
                    dir="ltr"
                    value={activeLeads}
                    max={totalLeads > 0 ? totalLeads : 100}
                  />
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Leads Activos</p>
                  <h5 className="mb-3">{activeLeads.toLocaleString()}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-muted me-2">
                      {" "}
                      Últimos 30 días
                    </span>
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-warning font-size-20">
                      <i className="ri-alarm-warning-line"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Necesitan Seguimiento</p>
                  <h5 className="mb-3">{needsFollowUp.toLocaleString()}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-warning me-2">
                      {" "}
                      Requieren atención
                    </span>
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
